import React from 'react';
import Offer from '../Offer/Offer';
import boilerImage from '@/src/resources/epd.png';
import { Heading2, Margin, P } from '@ovotech/nebula';
import { UnorderedListSection } from '../../UnorderedListSection';

/*
Electics plumbing and drainage product,
2026 £1 offer
*/
export const EPD = () => {
  return (
    <Offer
      offerId="homeplan-£1-epd"
      image={boilerImage}
      linkUrl="https://ovohomeservices.co.uk/electrics-plumbing-drainage/?promoCode=EPD2-4"
      linkText="Claim Offer"
      lowerBody={<P>Terms and eligibility apply</P>}
    >
      <Heading2>
        Electrics, Plumbing, and Drainage Cover for £1 per month
      </Heading2>
      <Margin bottom={4}>
        <UnorderedListSection
          title=""
          list={[
            'Repairs by expert plumbers and electricians',
            'Trusted by thousands of UK homes',
            '24/7 helpline | Unlimited callouts',
          ]}
        />
      </Margin>
    </Offer>
  );
};
